import {
  LineItemSupplier,
  PriceableItemOrigin,
  type SyncableLineItem,
} from "elephant-web/gql";

export const ELEPHANT_REGISTRATION_ID = "18c0c6a3-f4bc-4bfe-8d40-2865980dcaed";

export interface ExternalReference {
  origin: PriceableItemOrigin;
  foreignId: string;
}

export const buildIdempotencyKey = (
  externalReference: ExternalReference,
  scopeId: string,
): string =>
  `${externalReference.origin}:${externalReference.foreignId}:${scopeId}`;

export interface ResolvedPrice {
  priceListItemId: string;
  cost: number;
  revenueDepartmentId: string;
  tariffId: string;
}

export interface BuildLineItemArgs {
  id: string;
  externalReference: ExternalReference;
  scopeId: string;
  incurredAt: string;
  resolvedPrice: ResolvedPrice;
  /** The user who triggered this auto-generated charge (offline-first: the FE
   * stamps per-line-item attribution the v1 backend would have set). */
  actorId: string;
}

export const buildLineItem = ({
  id,
  externalReference,
  scopeId,
  incurredAt,
  resolvedPrice,
  actorId,
}: BuildLineItemArgs): SyncableLineItem => {
  const base = {
    id,
    automated: true,
    disabled: false,
    externalReference: {
      origin: externalReference.origin,
      foreignId: externalReference.foreignId,
    },
    idempotencyKey: buildIdempotencyKey(externalReference, scopeId),
    incurredAt,
    quantity: 1,
    supplier: LineItemSupplier.Government,
    actorId,
  };

  return {
    ...base,
    cost: resolvedPrice.cost,
    missingPrice: false,
    priceListItemId: resolvedPrice.priceListItemId,
    revenueDepartmentId: resolvedPrice.revenueDepartmentId,
    tariffId: resolvedPrice.tariffId,
  } as SyncableLineItem;
};
